// Stałe layoutu SVG
export const SVG_TOP_MARGIN = 80;
export const SVG_LEFT_MARGIN = 100;
export const SVG_RIGHT_PADDING = 120; // skala + etykiety
export const SVG_BOTTOM_PADDING = 80;
export const BOREHOLE_WIDTH = 37.5;
export const BOREHOLE_HALF_WIDTH = 18.75;

// Domyślne wartości skali
// Domyślne wyświetlane 1:N — pion 1:69, poziom 1:100.
// Wewnętrznie scale/10 = px/m (pion), horizontalScale = px/m (poziom),
// więc px/m = (1000 mm/m) × (96/25.4 px/mm) / N.
const _CSS_PX_PER_MM = 96 / 25.4;
export const DEFAULT_SCALE = (10 * 1000 * _CSS_PX_PER_MM) / 69;          // ≈ 547.76  → wyświetla 1:69 V
export const DEFAULT_HORIZONTAL_SCALE = (1000 * _CSS_PX_PER_MM) / 100;   // ≈ 37.80  → wyświetla 1:100 H

// Opcje wzorów geologicznych (warstwy)
export const LAYER_PATTERN_OPTIONS = [
  { value: 'none', label: 'Brak szrafuru' },
  { value: 'sand', label: 'Piasek (małe kropki)' },
  { value: 'clay', label: 'Glina (linie poziome)' },
  { value: 'gravel', label: 'Żwir (duże kropki)' },
  { value: 'rock', label: 'Skała (krzyżyk)' },
];

// Opcje wzorów geologicznych (soczewki) - legacy system
export const LENS_PATTERN_OPTIONS = [
  { value: 'none', label: 'Brak' },
  { value: 'dots', label: 'Kropki (żwir)' },
  { value: 'horizontal', label: 'Poziome (glina)' },
  { value: 'diagonal', label: 'Ukośne (piasek)' },
  { value: 'cross', label: 'Krzyżyk (kamień)' },
];

// Kolory edycji soczewek
export const LENS_EDIT_COLORS = {
  vertexDefault: '#2196F3',     // niebieski
  vertexMoved: '#9C27B0',       // fioletowy
  controlDefault: '#4CAF50',    // zielony
  controlMoved: '#FF6600',      // pomarańczowy
  reset: '#FF0000',             // czerwony
  helperLine: '#999',           // szary
  drawingPreview: '#FF6B00',    // pomarańczowy
};

// Rozmiary elementów edycji soczewek
export const LENS_EDIT_SIZES = {
  vertexRadius: 10,
  controlRadius: 8,
  resetRadius: 10,
};

// Współczynnik rozjaśniania dla kolorów pastelowych
export const PASTEL_LIGHTEN_FACTOR = 0.6;
